import { render, staticRenderFns } from "./service-block.vue?vue&type=template&id=79f40058"
import script from "./service-block.vue?vue&type=script&lang=js"
export * from "./service-block.vue?vue&type=script&lang=js"
import style0 from "./service-block.vue?vue&type=style&index=0&id=79f40058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports